import { createTranslationKeysObject } from "utils/createTranslationKeysObject";

import { enGb } from "../translations/en-gb";

export const TRANSLATION_KEYS = createTranslationKeysObject(enGb);
